export default __webpack_public_path__ + "static/media/list-alt-solid.17ed4dde.svg";